<template>
  <ListComponent title="Debit Note">
    <template #list>
      <v-row class="ma-0">
        <v-col cols="4" class="pl-0 pr-2 pt-0 pb-2 d-flex align-center">
          <v-text-field label="Search" outlined dense append-icon="mdi-magnify" clearable hide-details="auto"
            v-model="filters.search" @input="searchInvoice"></v-text-field>


          <Columns :headers="headers" :gridColInstance="gridColumnApi" />
        </v-col>

        <v-col cols="4" class="px-0 pt-0 pb-2">
          <v-tabs height="35" v-model="tab" centered>
            <v-tabs-slider></v-tabs-slider>
            <v-tab>
              Pending
              <v-badge v-if="totalDebitNoteStatistics.debit_note_pending" top
                :content="totalDebitNoteStatistics.debit_note_pending" overlap class="mb-4 ml-3">
              </v-badge>
            </v-tab>
            <v-tab>
              Accepted<v-badge v-if="totalDebitNoteStatistics.debit_note_accepted" top
                :content="totalDebitNoteStatistics.debit_note_accepted" overlap class="mb-4 ml-3">
              </v-badge>
            </v-tab>
            <!-- <v-tab> Rejected </v-tab> -->
          </v-tabs>
        </v-col>

        <v-col v-if="totalItems > 0" cols="4" class="px-0 pt-0 pb-2 d-flex justify-end">
          <Pagination :pageNo="pageNo" :totalItems="totalItems" :pageSize="itemsPerPage"
            @itemsPerPageChange="itemsPerPageChanged" @prevPage="prevPage" @nextPage="nextPage" />
        </v-col>

        <v-col cols="12" class="pa-0">
          <AgGridVue style="width: 100%; height: calc(100vh - 172px)" class="ag-theme-alpine" id="myGrid"
            :columnDefs="headers" :context="context" @grid-ready="onGridReady" @columnMoved="resizeGrid"
            @columnVisible="resizeGrid" :defaultColDef="defaultColDef" :grid-options="gridOptions"
            :suppressDragLeaveHidesColumns="true" :rowData="allDebitNoteList"></AgGridVue>
        </v-col>
      </v-row>


      <DetailsParent v-model="invoiceLogDetailsDrawer" :resizable="true">
        <template #details>
          <v-card elevation="0">
            <v-card-title class="heading">
              <span class="text-h6">Debit Note Log</span>
            </v-card-title>

            <v-card-text>
              <v-row class="Order-Log-Scrolling-Class mt-3">
                <v-col cols="12">
                  <span class="py-12" v-if="invoice_logs && invoice_logs.length == 0">
                    No logs to show!
                  </span>

                  <v-timeline dense clipped v-else>
                    <v-timeline-item v-for="(log, i) in invoice_logs" :key="i" icon-color="primary" small>
                      <v-card class="elevation-2">
                        <v-card-text>
                          <table class="Full-Width">
                            <tbody>
                              <tr>
                                <th class="text-left">{{ log.updated_by }}</th>
                                <td class="text-caption text-right">
                                  {{ log.created | formatDate(true) }}
                                </td>
                              </tr>
                              <tr>
                                <td colspan="2">{{ log.message }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </v-card-text>
                      </v-card>
                    </v-timeline-item>
                  </v-timeline>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
      </DetailsParent>

      <RemarksDialog v-model="showRemarksForm" :formDetails="updatingInvoice" :formErrors="formErrors"
        fieldKey="customer_remarks" :label="updatingInvoice.status + ' Remarks *'"
        @submitRemarks="updateDebitNoteStatus" />
      <CreditNoteAttachmentDialog v-model="showAttachmentdialog" :debitNoteID="debitNoteID" :debitNoteNo="debitNoteNo"
        @refreshList="itemsPerPageChanged(20)" />
    </template>

    <template #actions>
      <v-btn v-if="permissions && permissions.add" color="info" class="mb-2" depressed small
        name="debit-list-add-debit-note" @click="adddebitNote">
        <v-icon>mdi-plus</v-icon>
        <span>Create Debit Note</span>
      </v-btn>

    </template>
  </ListComponent>
</template>

<script>
import RemarksDialog from "@/components/ModuleBased/dialogs/RemarksDialog.vue";

import Columns from "@/components/General/Columns.vue";
import ListComponent from "@/components/General/ListComponent.vue";
import { AgGridVue } from "ag-grid-vue";
import AdminDebitNoteButton from "@/components/AgGridComponents/AdminDebitNoteButton.vue";
import Pagination from "@/components/General/Pagination.vue";
import CustomHeader from "@/components/AgGridComponents/General/CustomHeader.vue";
import DetailsParent from "@/components/General/DetailsParent.vue";
import CreditNoteAttachmentDialog from "@/components/ModuleBased/dialogForms/CreditNoteAttachmentDialog.vue";

import {
  isAuthenticated,
  hasRouteAccess,
  getPermissions,
} from "@/utils/functions";
import AdminCustomerInvoiceFilters from "@/components/ModuleBased/dialogs/filters/AdminCustomerInvoiceFilters.vue";

export default {
  components: {
    ListComponent,
    Columns,
    AgGridVue,
    RemarksDialog,
    AdminDebitNoteButton,
    agColumnHeader: CustomHeader,
    Pagination,
    AdminCustomerInvoiceFilters,
    DetailsParent,
    CreditNoteAttachmentDialog,
  },
  watch: {
    tab() {
      this.pageNo = 1;
      this.getDebitNoteList();
      this.invoiceLogDetailsDrawer = false;
    },
  },
  data() {
    return {
      showRemarksForm: false,

      formErrors: {},

      sorting: {},
      debitNoteID: null,
      updatingInvoice: {},
      headers: [
        {
          headerName: "Debit No",
          field: "debit_no",
          sortable: true,
          minWidth: 140,
        },
        {
          headerName: "Debit Note Date",
          field: "debit_note_date",
          sortable: true,
          minWidth: 140,
          valueFormatter: (params) => {
            return this.$globals.formatDate(params.value);
          },
        },
        {
          headerName: "Status",
          field: "status",
          sortable: true,
          minWidth: 150,
        },
          {
          headerName: "SubHire No",
          field: "subhire_no",
          sortable: true,
          minWidth: 150,
          valueGetter: (params) => {
    return params.data.subhire_no || "N/A";
  },
           onCellClicked: (params) => {
            if (
             
              params.data &&
              params.data.trip_pk
            )
           {
              const path = {
                path: `/admin/sub-hire/pending`,
                query: {},
              };
              this.$router.push(path);
            }
          },
             cellStyle: (params) => {
    return {
      color: params.value && params.value !== "N/A" ? "orange" : "gray",
      fontWeight: "bold",
    };
  },
        },
           {
          headerName: "DA No",
          field: "da_no",
          sortable: true,
          minWidth: 150,
          valueGetter: (params) => {
    return params.data.da_no || "N/A";
  },
           onCellClicked: (params) => {
            if (
             
              params.data &&
              params.data.da_no
            )
           {
              const path = {
                path: `/app/admin/delivery-advice/list`,
                query: {},
              };
              this.$router.push(path);
            }
          },
           cellStyle: (params) => {
    return {
      color: params.value && params.value !== "N/A" ? "orange" : "gray",
      fontWeight: "bold",
    };
  },
        },
        

        {
          headerName: "Transporter",
          field: "vendor_name",
          sortable: true,
          minWidth: 150,
        },

        {
          headerName: "Total Debit Amount",
          field: "total_debit_amount",
          sortable: true,
          minWidth: 140,
        },


        {
          headerName: "IS Full  Debit Note",
          field: "is_full_debit_note",
          sortable: true,
          minWidth: 150,
        },
        {
          headerName: "Remarks",
          field: "remarks",
          sortable: true,
          minWidth: 150,
        },

        {
          headerName: "Acknowledged By",
          field: "acknowledged_by",
          sortable: true,
          minWidth: 160,
        },
        {
          headerName: "Acknowledged On",
          field: "acknowledged_on",
          sortable: true,
          minWidth: 160,
        },

        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "AdminDebitNoteButton",
          pinned: "right",
          minWidth: 310,
        },
      ],
      permissions: null,

      // details vars
      selectedInvoiceId: null,
      debitNoteNo: null,
      showAttachmentdialog: false,
      showDetails: false,

      // Pagination Vars
      showFiltersDialog: false,
      tab: null,
      itemsPerPage: 20,
      pageNo: 1,
      totalItems: 0,
      filters: {},

      invoiceLogDetailsDrawer: false,
      invoice_logs: [],

      // Ag-grid vars
      gridApi: null,
      gridColumnApi: null,
      defaultColDef: {
        resizable: true,
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.resizeGrid();
        },
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
        tooltipShowDelay: 0,
        rowHeight: 35,
      },

      allDebitNoteList: [],
      totalDebitNoteStatistics: [],
      searchDebitNoteStatisticTimeout: null,
      daList: null,

      invoiceId: null,
      debitNoteID: null,
      downloadingInvoice: null,
    };
  },

  computed: {
    context() {
      return { parentComponent: this };
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
  },

  methods: {
    adddebitNote() {
      this.$router.push("/app/admin/invoice/debit-note/add");
    },

    createCreditNoteAttachment(data) {
      this.debitNoteNo = data.credit_no;
      this.debitNoteID = data?.id;
      this.showAttachmentdialog = true;
    },

    viewDebitNoteLogs(debitNoteID) {
      this.invoiceLogDetailsDrawer = true;
      this.$bus.$emit("showLoader", false);
      this.$api.customerInvoice
        .getDebitNoteLogs(debitNoteID)
        .then((res) => {
          this.invoice_logs = res.data;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't fetch invoice logs!",
            color: "error",
          });
          this.formErrors = err.data;
        });
    },

   

    updateDebitNoteStatus() {
      console.log("33899", this.updatingInvoice.id, this.updatingInvoice);

      this.$api.customerInvoice
        .partiallyUpdateStatusDebitNote(
          this.updatingInvoice.id,
          this.updatingInvoice
        )
        .then((res) => {
          this.getDebitNoteList();
          this.showRemarksForm = false;
          this.$bus.$emit("showToastMessage", {
            message: "Debit Note status updated successfully!",
            color: "success",
          });
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't update  status!",
            color: "error",
          });
          this.formErrors = err.data;
        });
    },

    openRemarksForm(data, status) {
      this.updatingInvoice = {
        id: data.id,
        status: status,
        customer_remarks: null,
      };
      this.showRemarksForm = true;
    },
    resizeGrid() {
      if (this.gridOptions && "api" in this.gridOptions) {
        setTimeout(() => {
          this.gridOptions.api.sizeColumnsToFit();
        }, 100);
      }
    },
    resetFilters() {
      this.filters = {};
      this.itemsPerPageChanged(20);
    },
    applyGridSort(key, type) {
      if (this.filters && !this.filters.ordering) {
        this.filters.ordering = [];
      }

      if (type == null) {
        delete this.sorting[key];
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(`-${key}`),
          1
        );
      } else if (type == "asc") {
        this.filters.ordering.push(key);
      } else if (type == "desc") {
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(key),
          1,
          `-${key}`
        );
      }
      if (this.filters.ordering.length == 0) {
        delete this.filters.ordering;
      }
      this.itemsPerPageChanged(20);
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.resizeGrid();
    },

    searchInvoice() {
      this.pageNo = 1;
      this.getDebitNoteList();
    },

    itemsPerPageChanged(e) {
      this.pageNo = 1;
      this.itemsPerPage = e;
      this.getDebitNoteList();
    },

    prevPage() {
      this.pageNo--;
      this.getDebitNoteList();
    },

    nextPage() {
      this.pageNo++;
      this.getDebitNoteList();
    },
    getTotalDebitNoteCount(params) {
      if (this.searchDebitNoteStatisticTimeout) {
        clearTimeout(this.searchDebitNoteStatisticTimeout);
      }
      this.searchDebitNoteStatisticTimeout = setTimeout(() => {
        params = { ...this.filters };
        delete params.limit;
        delete params.offset;
        delete params.statuses;
        this.$api.customerInvoice
          .getDebitNoteListStatistics(params)
          .then((res) => {
            this.totalDebitNoteStatistics = res.data;
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't  Invoice!",
              color: "error",
            });
          });
      }, 1000);
    },

    getDebitNoteList(params = {}) {
      this.$bus.$emit("showLoader", true);
      params = {
        offset: this.offset,
        limit: this.itemsPerPage,
        ...params,
        ...this.filters,
        status:
          this.tab == 0
            ? "Pending"
            : this.tab == 1
              ? "Accepted"
              : this.tab == 2
                ? "Rejected"
                : "Rejected",
      };
      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }
      this.$api.customerInvoice
        .getDebitNoteList(params)
        .then((res) => {
          this.allDebitNoteList = res.data;
          this.totalItems = res.count;
          this.getTotalDebitNoteCount();
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

   
    checkQuery() {
      if ("active_tab" in this.$route.query) {
        this.tab = parseInt(this.$route.query.active_tab);
      }
      this.getTotalDebitNoteCount();
    },
  },

  beforeMount() {
    if (!isAuthenticated()) {
      this.$router.push("/");
    } else if (!hasRouteAccess(this.$route)) {
      this.$router.push(`/${localStorage.getItem("user_type").toLowerCase()}`);
    } else {
      const permissions = getPermissions("invoice");
      if (!permissions || !permissions.view) {
        this.$bus.$emit("showToastMessage", {
          message: "You don't have access to this page",
          color: "error",
        });
        this.$router.push(
          `/app/${localStorage.getItem("user_type")
            ? localStorage.getItem("user_type").toLowerCase()
            : "error"
          }`
        );
      } else {
        this.permissions = { ...permissions };
      }
    }
  },

  mounted() {
    this.checkQuery();
    this.getTotalDebitNoteCount();
  },
};
</script>

<style scoped>
.Height-Class {
  height: calc(100vh - 160px);
  overflow-y: auto;
}
</style>
